module.exports = __webpack_public_path__ + "static/media/logo_grey.bd441009.svg";